import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Loader2, Check, AlertCircle, ArrowRight } from 'lucide-react';
import SEO from '@/components/SEO';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function UnsubscribePage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState(token ? 'loading' : 'no-token');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) return;
    axios.get(`${API}/public/unsubscribe/${token}`)
      .then(r => { setStatus('success'); setMessage(r.data.message); })
      .catch(err => { setStatus('error'); setMessage(err.response?.data?.detail || 'This unsubscribe link is invalid or has expired.'); });
  }, [token]);

  return (
    <div data-testid="unsubscribe-page">
      <SEO title="Unsubscribe" path="/unsubscribe" noindex />
      <section className="py-20 sm:py-28">
        <div className="max-w-md mx-auto px-4 sm:px-8 text-center">
          {status === 'loading' && (
            <div>
              <Loader2 className="w-8 h-8 text-[#3A4035] animate-spin mx-auto mb-4" />
              <p className="text-sm text-[#5C5C55]">Processing your request...</p>
            </div>
          )}
          {status === 'success' && (
            <div className="animate-fade-in" data-testid="unsubscribe-success">
              <div className="w-14 h-14 rounded-2xl bg-[#E8EDE5] flex items-center justify-center mx-auto mb-5">
                <Check className="w-7 h-7 text-[#3A4035]" strokeWidth={1.5} />
              </div>
              <h1 className="font-heading text-2xl font-medium text-[#1A1A1A] tracking-tight mb-3">Unsubscribed</h1>
              <p className="text-sm text-[#5C5C55] leading-relaxed">{message}</p>
            </div>
          )}
          {status === 'error' && (
            <div className="animate-fade-in" data-testid="unsubscribe-error">
              <div className="w-14 h-14 rounded-2xl bg-[#FDF2F2] flex items-center justify-center mx-auto mb-5">
                <AlertCircle className="w-7 h-7 text-[#B33A3A]" strokeWidth={1.5} />
              </div>
              <h1 className="font-heading text-2xl font-medium text-[#1A1A1A] tracking-tight mb-3">Something went wrong</h1>
              <p className="text-sm text-[#5C5C55] leading-relaxed">{message}</p>
            </div>
          )}
          {status === 'no-token' && (
            <div className="animate-fade-in">
              <h1 className="font-heading text-2xl font-medium text-[#1A1A1A] tracking-tight mb-3">Unsubscribe</h1>
              <p className="text-sm text-[#5C5C55] leading-relaxed">Use the unsubscribe link from your email to manage your preferences.</p>
            </div>
          )}
          <div className="mt-8">
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#5C5C55] hover:text-[#3A4035] transition-colors">
              <ArrowRight className="w-4 h-4 rotate-180" strokeWidth={1.5} /> Back to home
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
